import useSwr from 'swr';
import toast from 'react-hot-toast';

import PollList, { PollListProps } from '@components/elements/PollList';
import { formatPollData, FormattedPoll } from '@utils/Poll';
import { useEffect } from 'react';
import { listHotPledges } from '@sdk/managers/PledgesManager';
import { useAuth } from '@hooks/Auth';

const countTotalVote = (data: any[]) => {
  let total = 0;

  data.forEach((d: any) => {
    total += d.count;
  });

  return total;
};

const getHotPollData = async (_query: string) => {
  const getListPolls: any = await listHotPledges();
  const {
    data: {
      result: { items },
    },
  } = getListPolls;
  let formattedPolls = (await Promise.all(
    items
      .filter((item) => item.poll)
      .map(async ({ poll }) => {
        const data = {
          ...poll,
          votes: countTotalVote(poll.voteResults.items),
        };
        return formatPollData(data);
      })
  )) as FormattedPoll[];

  formattedPolls = formattedPolls.filter((poll) => {
    if (poll.status === 'CLOSED') {
      return false;
    }

    return true;
  });

  formattedPolls.sort((a: FormattedPoll, b: FormattedPoll) => {
    return (
      b.voteCount - a.voteCount ||
      new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
    );
  });

  return formattedPolls;
};

interface HotPollsProps extends Omit<PollListProps, 'data' | 'loading'> {
  onSelectPoll: (poll: FormattedPoll) => any;
}

const HotPolls: React.FC<HotPollsProps> = ({
  onSelectPoll,
  ...pollListProps
}) => {
  const { company, dbUser } = useAuth();
  const { data, error } = useSwr<FormattedPoll[]>(
    [
      '/poll/hot/pledge',
      company?.companyID,
      dbUser?.postalInfo?.grc,
      dbUser?.postalInfo?.division,
    ],
    getHotPollData
  );

  useEffect(() => {
    console.log('pledge', error);
    if (error) toast.error(error.message);
  }, [error]);

  return (
    <PollList
      data={data}
      loading={!data}
      onSelect={onSelectPoll}
      {...pollListProps}
    />
  );
};

export default HotPolls;
